<template>
  <div>
    <record-list v-show="tabType === 1" @handleShow="handleShow" />
    <record-show
      v-if="tabType === 2"
      :rowItem="rowItem"
      @handleShow="handleShow"
      :activeName="activeName"
    />
  </div>
</template>

<script>
import recordList from "./list.vue";
import recordShow from "./show.vue";
export default {
  components: { recordList, recordShow },
  data() {
    return {
      tabType: 1,
      rowItem: null,
      activeName: null
    };
  },
  methods: {
    handleShow(row, type, activeName) {
      this.rowItem = { ...row };
      this.activeName = +activeName;
      this.tabType = type;
    }
  }
};
</script>

<style></style>
